import type { Evidence } from '@kilroy/shared';
import { EvidenceRow } from './EvidenceRow';

/* A list of evidence inside a card.
 *
 * Extracted once this shape appeared on a third screen. The card is not
 * decoration: EvidenceRow draws its own hairline separators and expects to sit
 * flush against a card edge, so a caller that forgets the wrapper gets rows
 * floating on the page background with their rules running into nothing.
 *
 * The empty case lives here too, because "no rows" is a state of this list
 * rather than something each screen should remember to handle — and forgetting
 * it renders an empty card, which reads as a loading bug.
 */
export function EvidenceList({
  evidence,
  empty,
  hint,
}: {
  evidence: Evidence[];
  empty: string;
  hint?: string;
}) {
  if (evidence.length === 0) {
    return (
      <div className="card empty">
        <div className="empty__t">{empty}</div>
        {hint && <div className="empty__h">{hint}</div>}
      </div>
    );
  }
  return (
    <div className="card">
      {evidence.map((e) => (
        <EvidenceRow key={e.id} evidence={e} />
      ))}
    </div>
  );
}
